import { makeStyles } from "@material-ui/styles";


const useStyle = makeStyles({
    requestGroupParent: {
        width: "100%",
        "@media (min-width: 700px)": {
            width: "45%",
        },
    },
    divider: {
        width:"100%",
        height:1,
        margin: "1rem 0",
        borderColor: "#ccc",
        "@media (min-width: 700px)": {
            height: "150px",
            margin: "0 2rem",
            width: "1px",
        },
    },
});
export default useStyle;
